import { render } from "./EmployeeDelegateApprovals.vue?vue&type=template&id=8f5f7238"
import script from "./EmployeeDelegateApprovals.vue?vue&type=script&lang=js"
export * from "./EmployeeDelegateApprovals.vue?vue&type=script&lang=js"

import "./EmployeeDelegateApprovals.vue?vue&type=style&index=0&id=8f5f7238&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__